import { createContext } from 'react';

export const postContext = createContext({});

export default postContext;
